export const maxVoucherCount = 10;
